import { SafeAreaComponent as SafeArea } from './SafeArea';
import { WrapperComponent as Wrapper, WrapperProps } from './Wrapper';

export { Wrapper, SafeArea };

export type { WrapperProps };
